export const regex =
  /\b([aA4][bB][ou0]{0,2}|[bB]00ng|[bB]o[o0]ng)(?:[sS5]{0,2})\b/;
export const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])+(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])+)+$/;
export const userRegex = /^[^a-zA-Z]/;
